export default {
  localStorage: {
    user: '',
    token: '',
  },
  linkType: {
    iframe: 'iframe',
    video: 'video',
    fbx: 'fbx'
  },
  pageType: {
    inform: 'inform',
    memory: 'memory',
    advertisement: 'advertisement',
    hotNews: 'hotNews',
    building: 'building'
  }
}
